export default __webpack_public_path__ + "static/media/pic55.2a84b9f6.jpg";